import { PropsWithChildren, useEffect, useState } from "react"
import { Outlet, useLocation } from "react-router"
import { PageContainer } from "../containers"
import { Spacer } from "../../../../components/spacer/Spacer"
import { SContentWrapper, SSectionWrapper } from "../acquisitionForm/AcquisitionForm.styled"
import { theme } from "../../../../styles/stitches.config"

function TransitionWrapper(props: PropsWithChildren) {
  const { children } = props

  const location = useLocation()

  const [isFirstRender, setIsFirstRender] = useState(true)

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false)
      return
    }

    // reseting scroll in iframe parent
    window.parent.postMessage({ action: "resetScroll" }, "*")
    // reseting scroll in the page itself
    document.body.scrollTop = document.documentElement.scrollTop = 0

    window.parent?.postMessage("scrollToAcquisitionFormTop", "*")
  }, [location.pathname, isFirstRender])

  return <>{children}</>
}

export function AcquisitionFormPageWrapper() {
  return (
    <PageContainer>
      <Spacer size={theme.space.s21} />
      <SContentWrapper>
        <TransitionWrapper>
          <SSectionWrapper>
            <Outlet />
          </SSectionWrapper>
        </TransitionWrapper>
      </SContentWrapper>
    </PageContainer>
  )
}
